(function () {
  'use strict';

  var VERSION = '1';
  var PARAMS = {
    version: 'cz_measurement_version',
    source: 'cz_measurement_source',
    type: 'cz_measurement_type',
    header: 'cz_measurement_header',
    width: 'cz_width',
    widthFraction: 'cz_width_fraction',
    length: 'cz_length',
    lengthFraction: 'cz_length_fraction',
    quantity: 'cz_quantity'
  };
  var parameterNames = Object.keys(PARAMS).map(function (key) {
    return PARAMS[key];
  });

  function cleanText(value) {
    return String(value || '')
      .replace(/[\u00a0\u202f]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function greatestCommonDivisor(a, b) {
    while (b) {
      var next = a % b;
      a = b;
      b = next;
    }
    return a;
  }

  function splitMeasurement(value) {
    var normalized = cleanText(value).replace(/\s*\/\s*/g, '/');
    var mixed = normalized.match(/^(\d+)(?:\s+(\d+)\/(\d+))?$/);
    if (mixed) {
      return {
        whole: String(parseInt(mixed[1], 10)),
        fraction: mixed[2] ? mixed[2] + '/' + mixed[3] : '0'
      };
    }

    var decimal = Number(normalized);
    if (!Number.isFinite(decimal) || decimal < 0) return null;
    var whole = Math.floor(decimal);
    var numerator = Math.round((decimal - whole) * 8);
    if (numerator === 8) {
      whole += 1;
      numerator = 0;
    }
    if (!numerator) return { whole: String(whole), fraction: '0' };
    var divisor = greatestCommonDivisor(numerator, 8);
    return {
      whole: String(whole),
      fraction: String(numerator / divisor) + '/' + String(8 / divisor)
    };
  }

  function parseMeasurementResult(root, type) {
    var text = cleanText(root && root.textContent);
    var size = text.match(
      /(\d+(?:\.\d+)?(?:\s+\d+\s*\/\s*\d+)?)\s*[\"”]?\s*W\s*[×xX]\s*(\d+(?:\.\d+)?(?:\s+\d+\s*\/\s*\d+)?)\s*[\"”]?\s*L/i
    );
    if (!size) return null;

    var width = splitMeasurement(size[1]);
    var length = splitMeasurement(size[2]);
    if (!width || !length) return null;

    var headerMatch = text.match(/Header:\s*(Pleated|Ripple\s*Fold|Soft\s*Top|Grommet)/i);
    var quantityMatch = text.match(/Quantity:\s*(\d+)/i);
    return {
      type: type === 'drapery' ? 'drapery' : 'shade',
      header: headerMatch
        ? cleanText(headerMatch[1]).toLowerCase().replace(/\s+/g, '-')
        : '',
      width: width.whole,
      widthFraction: width.fraction,
      length: length.whole,
      lengthFraction: length.fraction,
      quantity: quantityMatch ? String(parseInt(quantityMatch[1], 10)) : ''
    };
  }

  function storefrontOrigin() {
    return window.location.origin === 'null' ? new URL(document.baseURI).origin : window.location.origin;
  }

  function readMeasurementFromUrl(url) {
    var search = new URL(url || window.location.href, storefrontOrigin()).searchParams;
    if (!search.get(PARAMS.width) || !search.get(PARAMS.length)) return null;
    return {
      type: search.get(PARAMS.type) || 'shade',
      header: search.get(PARAMS.header) || '',
      width: search.get(PARAMS.width),
      widthFraction: search.get(PARAMS.widthFraction) || '0',
      length: search.get(PARAMS.length),
      lengthFraction: search.get(PARAMS.lengthFraction) || '0',
      quantity: search.get(PARAMS.quantity) || ''
    };
  }

  function addMeasurementToUrl(destination, measurement) {
    var url = new URL(destination, storefrontOrigin());
    url.searchParams.set(PARAMS.version, VERSION);
    url.searchParams.set(PARAMS.source, 'measurement-tool');
    url.searchParams.set(PARAMS.type, measurement.type);
    url.searchParams.set(PARAMS.width, measurement.width);
    url.searchParams.set(PARAMS.widthFraction, measurement.widthFraction);
    url.searchParams.set(PARAMS.length, measurement.length);
    url.searchParams.set(PARAMS.lengthFraction, measurement.lengthFraction);
    if (measurement.header) url.searchParams.set(PARAMS.header, measurement.header);
    if (measurement.quantity) url.searchParams.set(PARAMS.quantity, measurement.quantity);
    return url.toString();
  }

  function copyMeasurementParameters(sourceUrl, destinationUrl) {
    var source = new URL(sourceUrl, storefrontOrigin());
    var destination = new URL(destinationUrl, storefrontOrigin());
    parameterNames.forEach(function (name) {
      if (source.searchParams.has(name)) {
        destination.searchParams.set(name, source.searchParams.get(name));
      }
    });
    return destination.toString();
  }

  function decorateProductLink(anchor) {
    if (!anchor || !anchor.href) return;
    var destination;
    try {
      destination = new URL(anchor.href, storefrontOrigin());
    } catch (error) {
      return;
    }
    if (destination.origin !== storefrontOrigin()) return;
    if (destination.pathname.indexOf('/products/') !== 0) return;
    anchor.href = copyMeasurementParameters(window.location.href, destination.toString());
  }

  function installCollectionPropagation() {
    if (!readMeasurementFromUrl(window.location.href)) return;
    var decorateAll = function () {
      document.querySelectorAll('a[href*="/products/"]').forEach(decorateProductLink);
    };
    decorateAll();
    document.addEventListener(
      'click',
      function (event) {
        var anchor = event.target && event.target.closest
          ? event.target.closest('a[href*="/products/"]')
          : null;
        decorateProductLink(anchor);
      },
      true
    );
    new MutationObserver(decorateAll).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function isUsableSelect(select) {
    if (!select || select.disabled || select.getClientRects().length === 0) return false;
    var style = window.getComputedStyle(select);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function optionSelects() {
    return Array.prototype.slice
      .call(document.querySelectorAll('select.ymq-option-native-select, select.ymq-dropdown'))
      .filter(isUsableSelect);
  }

  function fieldSelect(kind) {
    return optionSelects().find(function (select) {
      var name = cleanText([select.name, select.getAttribute('aria-label')].join(' ')).toLowerCase();
      if (kind === 'widthFraction') return name.indexOf('width') !== -1 && name.indexOf('fraction') !== -1;
      if (kind === 'lengthFraction') return name.indexOf('length') !== -1 && name.indexOf('fraction') !== -1;
      if (kind === 'width') return name.indexOf('width') !== -1 && name.indexOf('fraction') === -1;
      return name.indexOf('length') !== -1 && name.indexOf('fraction') === -1;
    });
  }

  function matchingOption(select, value) {
    var normalized = cleanText(value);
    return Array.prototype.slice.call(select.options).find(function (option) {
      return cleanText(option.value) === normalized || cleanText(option.textContent) === normalized;
    });
  }

  function setSelectValue(select, option) {
    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLSelectElement.prototype,
      'value'
    ).set;
    setter.call(select, option.value);
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function detectedHeaderType() {
    var value = cleanText(window.location.pathname + ' ' + document.title).toLowerCase();
    if (/ripple[-_\s]*fold/.test(value)) return 'ripple-fold';
    if (/soft[-_\s]*top/.test(value)) return 'soft-top';
    if (/grommet/.test(value)) return 'grommet';
    return 'pleated';
  }

  function isCompatibleProduct(measurement) {
    if (measurement.type !== 'drapery' || !measurement.header) return true;
    return measurement.header === detectedHeaderType();
  }

  function fieldsMatchMeasurementType(measurement, fields) {
    var names = cleanText([
      fields.width && fields.width.name,
      fields.length && fields.length.name
    ].join(' ')).toLowerCase();
    var isDraperyField = /single\s*panel|total\s*coverage/.test(names);
    return measurement.type === 'drapery' ? isDraperyField : !isDraperyField;
  }

  function setQuantity(quantity) {
    if (!quantity) return false;
    var input = Array.prototype.slice
      .call(document.querySelectorAll('input[name="quantity"]'))
      .find(function (candidate) {
        return candidate.type === 'number' && candidate.getClientRects().length > 0;
      });
    if (!input) return false;
    var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(input, quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function tryApplyMeasurement(measurement) {
    var fields = {
      width: fieldSelect('width'),
      widthFraction: fieldSelect('widthFraction'),
      length: fieldSelect('length'),
      lengthFraction: fieldSelect('lengthFraction')
    };
    if (!fields.width || !fields.widthFraction || !fields.length || !fields.lengthFraction) {
      return false;
    }
    if (!fieldsMatchMeasurementType(measurement, fields)) {
      document.documentElement.setAttribute('data-cz-measurement-status', 'product-type-mismatch');
      return 'stop';
    }
    if (!isCompatibleProduct(measurement)) {
      document.documentElement.setAttribute('data-cz-measurement-status', 'header-mismatch');
      return 'stop';
    }

    var options = {
      width: matchingOption(fields.width, measurement.width),
      widthFraction: matchingOption(fields.widthFraction, measurement.widthFraction),
      length: matchingOption(fields.length, measurement.length),
      lengthFraction: matchingOption(fields.lengthFraction, measurement.lengthFraction)
    };
    if (!options.width || !options.widthFraction || !options.length || !options.lengthFraction) {
      document.documentElement.setAttribute('data-cz-measurement-status', 'size-unavailable');
      return 'stop';
    }

    setSelectValue(fields.width, options.width);
    setSelectValue(fields.widthFraction, options.widthFraction);
    setSelectValue(fields.length, options.length);
    setSelectValue(fields.lengthFraction, options.lengthFraction);
    if (measurement.type === 'drapery' && measurement.quantity) {
      setQuantity(measurement.quantity);
      window.setTimeout(function () {
        setQuantity(measurement.quantity);
      }, 400);
      window.setTimeout(function () {
        setQuantity(measurement.quantity);
      }, 1200);
    }

    document.documentElement.setAttribute('data-cz-measurement-status', 'applied');
    window.dispatchEvent(
      new CustomEvent('cozyology:measurement-applied', { detail: measurement })
    );
    return true;
  }

  function installProductAutofill() {
    var measurement = readMeasurementFromUrl(window.location.href);
    if (!measurement) return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var result = tryApplyMeasurement(measurement);
      if (result === true || result === 'stop' || attempts >= 80) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function boot() {
    // Isolated report owns Shop Now; no native-result scraping.
    installCollectionPropagation();
    if (window.location.pathname.indexOf('/products/') === 0) {
      installProductAutofill();
    }
  }

  window.CozyologyMeasurementTransfer = {
    version: VERSION,
    splitMeasurement: splitMeasurement,
    parseMeasurementResult: parseMeasurementResult,
    readMeasurementFromUrl: readMeasurementFromUrl,
    addMeasurementToUrl: addMeasurementToUrl,
    tryApplyMeasurement: tryApplyMeasurement
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
